var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7345 2.50544C16.1314 2.50544 15.5282 2.73513 15.0678 3.19555L14.0913 4.17211L17.4246 7.50544L18.4012 6.52888C19.3212 5.60888 19.3212 4.11638 18.4012 3.19555C17.9407 2.73513 17.3376 2.50544 16.7345 2.50544ZM12.8413 5.42211L3.25793 15.0054V18.3388H6.59127L16.1746 8.75544L12.8413 5.42211Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.c94a4da80971fe4986ceaa261135f063.svg";
export { ForwardRef as ReactComponent };